import { retrievePersistentData, storePersistentData } from './persistent-data/persistent-data';
import { generateUID } from './uidGenerator';

const retrieveDeviceId = (): string => {
  let deviceId = retrievePersistentData<string>('uid');
  if (!deviceId) {
    deviceId = generateUID();
    storePersistentData('uid', deviceId, false);
  }
  return deviceId;
};

export default retrieveDeviceId;
